// extracted by mini-css-extract-plugin
export default {"main":"end_main__BSqlF","imageP":"end_imageP__HDSXr","link":"end_link__NwAGw"};